(() => {
  const script = document.querySelector('[data-ep-static-handle]');
  const page = document.querySelector('[data-template-page]');
  const content = page?.querySelector('.page-content');
  if (!script || !page || !content || page.dataset.epStaticReady) return;
  page.dataset.epStaticReady = 'true';
  page.classList.add('ep-static-page');
  const faq = script.dataset.epStaticHandle === 'faqs';
  page.classList.toggle('ep-static-page--faq', faq);
  const headings = [...content.children].filter(node => node.tagName === 'H2');
  if (!headings.length) return;
  const layout = document.createElement('div');
  layout.className = 'ep-static-layout';
  const nav = document.createElement('nav');
  nav.className = 'ep-static-nav';
  nav.setAttribute('aria-label', faq ? 'Question categories' : 'On this page');
  const label = document.createElement('strong');
  label.textContent = faq ? 'Browse questions' : 'On this page';
  nav.append(label);
  content.parentNode.insertBefore(layout, content);
  layout.append(nav, content);
  headings.forEach((heading, index) => {
    heading.id = `ep-page-section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    nav.append(link);
  });
  if (faq) {
    [...content.querySelectorAll(':scope > h3')].forEach(question => {
      const details = document.createElement('details');
      details.className = 'ep-faq-question';
      const summary = document.createElement('summary');
      const answer = document.createElement('div');
      answer.className = 'ep-faq-answer';
      let node = question.nextSibling;
      question.parentNode.insertBefore(details, question);
      while (node && !['H2', 'H3'].includes(node.nodeName)) {
        const next = node.nextSibling;
        answer.append(node);
        node = next;
      }
      summary.append(question);
      details.append(summary, answer);
    });
    const first = content.querySelector('details');
    if (first) first.open = true;
  }
  if (script.dataset.epStaticHandle === 'shipping-policy') {
    const deliveryHeadings = [...content.querySelectorAll(':scope > h3')].filter(node => /^Royal Mail Tracked (24|48)$/.test(node.textContent.trim()));
    if (deliveryHeadings.length === 2) {
      const cards = document.createElement('div');
      cards.className = 'ep-delivery-cards';
      deliveryHeadings[0].before(cards);
      deliveryHeadings.forEach(heading => {
        const card = document.createElement('section');
        card.className = 'ep-delivery-card';
        const list = heading.nextElementSibling;
        card.append(heading);
        if (list?.tagName === 'UL') card.append(list);
        cards.append(card);
      });
    }
  }
  if (faq) {
    const help = document.createElement('aside');
    help.className = 'ep-static-help';
    const text = document.createElement('div');
    const title = document.createElement('h2');
    title.textContent = 'Need help?';
    const email = document.createElement('a');
    email.href = 'mailto:support@excellentpick.co.uk';
    email.textContent = 'support@excellentpick.co.uk';
    const contact = document.createElement('a');
    contact.href = '/pages/contact-us';
    contact.className = 'ep-static-help-button';
    contact.textContent = 'Contact us';
    text.append(title, email);
    help.append(text, contact);
    content.append(help);
  }
})();
